/**
 * Any getters for easy access to things in store
 */
export const getters = {
  getProps: state => state.defaultProps,
  getIcon: () => 'announcement'
};
